import './index.css'

const LifeAtCompanySection = props => {
  const {lifeAtCompany} = props
  return (
    <div className="life-at-company-container">
      <div className="company-card">
        <h2>Life at Company</h2>
        <p className="life-at-company-para">{lifeAtCompany.description}</p>
      </div>
      <div className="company-img-card">
        <img
          src={lifeAtCompany.imageUrl}
          alt="life at company"
          className="life-at-company-img"
        />
      </div>
    </div>
  )
}

export default LifeAtCompanySection
